{
	"card": {
		"account": {
			"created": "Creato il",
			"email": "Email",
			"name": "Nome",
			"never": "Non verificata",
			"status": "Stato",
			"verified": "Email verificata il"
		},
		"applications": {
			"effective": "Fa fede dal {{date}}",
			"empty": "Nessuna domanda inviata.",
			"protocol": "Prot. {{protocol}}",
			"signed": "Inviata il {{date}}"
		},
		"commands": {
			"code": "Invia di nuovo il codice di accesso",
			"code_description": "Lo studente riceve un nuovo codice a sei cifre all'indirizzo dell'account, con il link alla pagina di accesso già pronta: va aperta con il browser da cui accede. Il codice che aveva prima smette di funzionare. Valgono gli stessi limiti della pagina di accesso: un codice al minuto.",
			"code_done": "Codice mandato.",
			"code_title": "Mandare un nuovo codice di accesso?",
			"confirm": "Invia",
			"no_applications": "Lo studente non ha domande firmate: non c'è nessuna ricevuta da mandare.",
			"receipt": "Invia di nuovo la ricevuta",
			"receipt_description": "Lo studente riceve una nuova email con la ricevuta della firma e gli orari aggiornati.",
			"receipt_done": "Ricevuta mandata.",
			"receipt_title": "Mandare di nuovo la ricevuta?"
		},
		"emails": {
			"empty": "Nessuna email.",
			"state": {
				"bounced": "Rimbalzata",
				"complained": "Segnalata come spam",
				"delivered": "Consegnata",
				"failed": "Non inviata",
				"queued": "In coda",
				"sent": "Inviata"
			},
			"template": {
				"receipt": "Ricevuta della firma",
				"sign_code": "Codice di firma",
				"sign_in_code": "Codice di accesso",
				"withdrawal_confirmed": "Ritiro confermato"
			}
		},
		"logged": "L'apertura di questa scheda è registrata nel registro degli accessi. Qui non si vedono i documenti caricati e non si cambia nessun dato.",
		"not_found": "Studente non trovato",
		"requests": {
			"answer": "Risposta: {{answer}}",
			"answer_label": "Risposta data",
			"answer_required": "Scrivi la risposta data.",
			"close": "Chiudi",
			"close_description": "Scrivi la risposta che hai dato allo studente.",
			"close_done": "Richiesta chiusa.",
			"close_submit": "Chiudi con la risposta",
			"close_title": "Chiudi la richiesta",
			"closed": "Chiusa",
			"closed_at": "Chiusa il {{date}}",
			"empty": "Nessuna richiesta.",
			"new": "Apri una richiesta",
			"new_description": "Scrivi cosa chiede lo studente. Resta aperta finché non la chiudi con la risposta data.",
			"new_done": "Richiesta aperta.",
			"new_submit": "Apri la richiesta",
			"new_title": "Apri una richiesta di assistenza",
			"open": "Aperta",
			"opened": "Aperta il {{date}}",
			"summary": "Cosa chiede lo studente",
			"summary_required": "Scrivi cosa chiede lo studente."
		},
		"sections": {
			"account": "Account",
			"applications": "Domande",
			"commands": "Invii",
			"emails": "Ultime email",
			"requests": "Richieste di assistenza"
		},
		"state": {
			"submitted": "Valida",
			"superseded": "Sostituita",
			"withdrawn": "Ritirata"
		},
		"status": {
			"active": "Attivo",
			"banned": "Bloccato",
			"deleted": "Eliminato"
		},
		"title": "Scheda di assistenza"
	},
	"page_title": "Assistenza",
	"search": {
		"applications_one": "{{count}} domanda",
		"applications_other": "{{count}} domande",
		"hint": "Ogni ricerca e ogni scheda aperta sono registrate nel registro degli accessi, con il tuo nome e gli studenti visti. Non serve scrivere un motivo.",
		"label": "Email, protocollo o codice fiscale",
		"no_name": "Nome non indicato",
		"none": "Nessuno studente trovato",
		"placeholder": "es. nome@esempio.it, 12 o RSSMRA00A01H501Z",
		"results": "Risultati",
		"submit": "Cerca",
		"submit_again": "Cerca di nuovo",
		"too_many": "Troppi risultati: scrivi un'email più lunga, un protocollo o un codice fiscale intero."
	}
}
